import {Base} from "@/api/Base"

export class MpfEdit extends Base {
    path = "mpf/edit"
}